/* SALITE Header – Startseite: durchsichtig oben, farbige Leiste bei
   Scrollen, Maus darüber, Antippen, Tastatur-Fokus oder offenem Länderfenster.
   Läuft erst, wenn die Seite fertig geladen ist (Hero-Bild muss existieren). */
(function () {
  function init() {
    if (window.__saliteHeaderSolid) return;
    var section = document.querySelector('.shopify-section--header');
    if (!section || !document.body.classList.contains('template-index')) return;
    if (!document.querySelector('.sal-hero__img')) return;
    window.__saliteHeaderSolid = true;

    var bar = section.querySelector('.header') || section;
    var threshold = 40;
    var canHover = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
    var state = { scrolled: false, hover: false, touch: false, focus: false };
    var ticking = false;

    function refresh() {
      var locOpen = !!section.querySelector('.salite-header-localizer.is-open');
      var solid = state.scrolled || state.hover || state.touch || state.focus || locOpen;
      section.classList.toggle('salite-header--solid', solid);
    }

    function onScroll() {
      state.scrolled = window.scrollY > threshold;
      refresh();
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(onScroll);
      }
    }, { passive: true });

    bar.addEventListener('pointerenter', function (e) {
      if ((!canHover || canHover.matches) && (e.pointerType === 'mouse' || e.pointerType === 'pen')) {
        state.hover = true;
        refresh();
      }
    });

    bar.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse' || e.pointerType === 'pen') {
        state.hover = false;
        refresh();
      }
    });

    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      state.touch = bar.contains(e.target);
      refresh();
    }, { passive: true });

    bar.addEventListener('focusin', function () {
      state.focus = true;
      refresh();
    });

    bar.addEventListener('focusout', function (e) {
      if (!bar.contains(e.relatedTarget)) {
        state.focus = false;
        refresh();
      }
    });

    /* Länderfenster auf/zu -> Leiste mitschalten */
    var loc = section.querySelector('.salite-header-localizer');
    if (loc && window.MutationObserver) {
      new MutationObserver(refresh).observe(loc, { attributes: true, attributeFilter: ['class'] });
    }

    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    window.__saliteHeaderSolid = false;
    init();
  });
})();
